import React from 'react';
import { Props } from '../';

const Bndl: React.FCC<Props> = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    viewBox="0 0 140 150"
    version="1.1"
    {...props}
  >
    <rect id="Logo" x="0" y="0" width="140.021" height="150" fill="none" />
    <g>
      <g id="c">
        <path
          d="M127.768,26.435l0,88.263c0,7.007 -5.679,13.181 -12.684,13.793l-89.762,7.835c-0.158,0.011 -0.311,0.023 -0.464,0.028l-0,1.52c-0,7.007 5.679,12.188 12.684,11.576l89.761,-7.835c7.006,-0.612 12.685,-6.786 12.685,-13.793l0,-89.782c0,-6.848 -5.43,-11.95 -12.214,-11.605l-0.006,0Z"
          fill="rgb(255,105,0)"
          fillRule="nonzero"
        />
        <rect
          x="24.858"
          y="117.954"
          width="99.509"
          height="18.759"
          fill="rgb(255,105,0)"
        />
        <rect
          x="114.015"
          y="26.432"
          width="13.827"
          height="104.027"
          fill="rgb(255,105,0)"
        />
        <path
          d="M115.163,13.328l-0,88.581c-0,7.007 -5.679,13.18 -12.685,13.793l-89.761,7.834l-0.074,0l0,1.208c0,7.007 5.68,12.188 12.685,11.576l89.761,-7.835c7.006,-0.612 12.685,-6.785 12.685,-13.793l-0,-89.782c-0,-6.984 -5.64,-12.154 -12.611,-11.582Z"
          fill="rgb(255,180,100)"
          fillRule="nonzero"
        />
        <rect
          x="101.573"
          y="13.33"
          width="13.827"
          height="104.027"
          fill="rgb(255,180,100)"
        />
        <rect
          x="12.644"
          y="100.119"
          width="99.509"
          height="23.426"
          fill="rgb(255,180,100)"
        />
        <rect
          x="16.491"
          y="22.481"
          width="86.753"
          height="81.438"
          fill="white"
        />
        <path
          d="M45.846,80.133c0.011,3.753 -2.63,7.421 -8.043,7.892l-3.99,0.278l-0.034,-14.383l3.99,-0.278c5.413,-0.47 8.065,2.778 8.077,6.491Zm-3.957,-38.028c1.559,-0.142 2.925,-0.851 2.925,-2.648c-0,-1.842 -1.366,-2.307 -2.925,-2.165l-8.484,0.669l-0,4.818l8.484,-0.668l0,-0.006Zm0.59,5.119l-9.069,0.72l0,5.21l9.075,-0.72c1.558,-0.142 3.117,-0.907 3.117,-2.863c-0,-1.995 -1.559,-2.483 -3.123,-2.341l-0,-0.006Zm50.579,37.473l-0.515,0.045l-0,1.174l0.515,-0.045c0.471,-0.04 0.732,-0.244 0.732,-0.647c-0,-0.402 -0.255,-0.567 -0.732,-0.527Zm22.105,-72.571l-0,89.783c-0,7.007 -5.679,13.18 -12.685,13.793l-89.761,7.834c-7.005,0.613 -12.684,-4.569 -12.684,-11.576l-0,-89.782c-0,-7.007 5.679,-13.181 12.684,-13.793l89.761,-7.835c7.006,-0.612 12.685,4.569 12.685,11.576Zm-89.518,20.03l0.017,28.192l16.397,-1.377c7.017,-0.63 11.971,-3.578 11.965,-9.57c0,-3.328 -2.38,-5.465 -4.642,-5.89c1.831,-0.868 3.622,-2.71 3.622,-5.613c-0,-5.714 -5.231,-7.636 -11.585,-7.069l-15.774,1.321l0,0.006Zm28.425,47.263c-0.023,-8.05 -6.15,-13.538 -16.193,-12.67l-12.249,0.992l0.074,28.141l12.248,-0.992c10.044,-0.873 16.142,-7.381 16.12,-15.471Zm31.53,4.246l-16.273,1.514l0,-21.344l-8.201,0.714l-0,28.249l24.468,-2.233l-0,-6.905l0.006,0.005Zm3.689,-57.218l-9.216,0.816l0,12.71l-16.64,-11.185l-2.33,0.204l0,28.283l9.171,-0.816l-0,-12.71l16.754,11.162l2.256,-0.198l-0,-28.272l0.005,0.006Zm7.465,59.225c-0,-2.052 -1.61,-3.526 -3.611,-3.35c-1.983,0.175 -3.57,1.927 -3.57,3.979c-0,2.053 1.587,3.532 3.57,3.357c2.001,-0.176 3.611,-1.922 3.611,-3.986Zm-0.743,0.063c0,1.655 -1.264,3.05 -2.868,3.191c-1.587,0.142 -2.833,-1.032 -2.833,-2.693c-0,-1.661 1.241,-3.05 2.833,-3.186c1.61,-0.141 2.868,1.043 2.868,2.688Zm-1.383,2.08l-0.827,-1.525c0.47,-0.21 0.776,-0.629 0.776,-1.145c0,-0.76 -0.589,-1.219 -1.411,-1.151l-1.383,0.119l0,3.946l0.76,-0.068l-0,-1.48l0.561,-0.051l0.708,1.417l0.811,-0.068l0.005,0.006Z"
          fill="rgb(30,38,71)"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);

export default Bndl;
